export const ADD_NEW_REVENUE_INPUT = `mutation ($totalRevenue: Float!, $data: [add_new_revenue_input_data]) {
  add_new_revenue_input(total_revenue: $totalRevenue, data: $data){
    message
  }
}`;

export const LIST_HOTEL_REVENUE_INPUTS = `query{
  list_hotel_revenue_inputs{
    message
    data {
      _id
      total_revenue
      data {
        month
        amount
      }
    }
  }
}`;

export const LIST_GENERATED_REVENUE = `query ($year: String) {
  list_generated_revenue(year: $year){
    message
    data {
      total_expected_revenue
      total_generated_revenue
      data {
        _id
        month
        expected_revenue
        generated_revenue
        is_expecation_meets
      }
    } 
  }
}`;

export const CHECK_ROOMTYPE_OFFER_RATES = `query ($roomtypeId: String!, $startDate: Int, $endDate: Int, $plusPercentage: Float, $minusPercentage: Float) {
  check_roomtype_offer_rates(roomtype_id: $roomtypeId, start_date: $startDate, end_date: $endDate, plus_percentage: $plusPercentage, minus_percentage: $minusPercentage) {
    message
    data {
      date
      standard_rate
      child_rate
      single_occupancy_rate
      max_occupancy_rate
      extra_bed_rate
    }
  }
}`;

export const ADD_NEW_PROPERTY_OFFER = `mutation ($startDate: Int!, $endDate: Int!, $type: String, $percentages: [add_new_property_offer_percentages]) {
  add_new_property_offer(start_date: $startDate, end_date: $endDate, type: $type, percentages: $percentages) {
    message
  }
}`;

export const UPDATE_PROPERTY_OFFER = `mutation ($id: String!, $startDate: Int!, $endDate: Int!, $type: String, $percentages: [update_property_offer_percentages]) {
  update_property_offer(_id: $id, start_date: $startDate, end_date: $endDate, type: $type, percentages: $percentages) {
    message
  }
}`;

export const SYNC_PROPERTY_OFFER = `mutation ($id: String!) {
  sync_property_offer(_id: $id) {
    message
  }
}`;

export const ACTIVATE_PROPERTY_OFFER = `mutation ($id: String!) {
  activate_property_offer(_id: $id) {
    message
  }
}`;

export const LIST_ALL_PROPERTY_OFFERS = `query ($pageSize: Int, $pageNumber: Int) {
  list_all_property_offers(page_size: $pageSize, page_number: $pageNumber) {
    message
    data {
      _id
      start_date
      end_date
      last_sync
      type
      sync_status
      is_active
    }
    hasMore
  }
}`;

export const LIST_PROPERTY_OFFER_DETAILS = `query ($id: String!) {
  list_property_offer_details(_id: $id) {
    message
    data {
      _id
      start_date
      end_date
      last_sync
      type
      is_active
      percentages {
        percentage
        standard_rate
        child_rate
        single_occupancy_rate
        max_occupancy_rate
        extra_bed_rate
        plus_percentage
        minus_percentage
      }
    }
  }
}`;

export const CHECK_PROPERTY_OFFER_RATES = `query ($startDate: Int, $endDate: Int, $plusPercentage: Float, $minusPercentage: Float) {
  check_property_offer_rates(start_date: $startDate, end_date: $endDate, plus_percentage: $plusPercentage, minus_percentage: $minusPercentage) {
    message
    data {
      date
      standard_rate
      child_rate
      single_occupancy_rate
      max_occupancy_rate
      extra_bed_rate
      roomtype_id {
        _id
        name
      }
    }
    roomtypes {
      _id
      name
    }
  }
}`;